import ConnectyCube from "connectycube";
import Handlebars from "handlebars";

const iOS = window.device?.platform === "iOS";
const isMobile =
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        navigator.userAgent || navigator.vendor || window.opera
    ) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        (navigator.userAgent || navigator.vendor || window.opera).substr(0, 4)
    );

class CallService {
    isOnline = window.navigator.onLine;

    iceRestartTimeout = null;
    needIceRestartForUsersIds = [];

    currentUser;

    init = (user) => {
        if (!user || !user.id) {
            console.error("[CallService][init] Invalid user: missing id", user);
            return;
        }

        user.id = Number(user.id);

        this.currentUser = user;

        ConnectyCube.videochat.onCallListener = this.onCallListener.bind(this);
        ConnectyCube.videochat.onAcceptCallListener =
            this.onAcceptCallListener.bind(this);
        ConnectyCube.videochat.onRejectCallListener =
            this.onRejectCallListener.bind(this);
        ConnectyCube.videochat.onStopCallListener =
            this.onStopCallListener.bind(this);
        ConnectyCube.videochat.onUserNotAnswerListener =
            this.onUserNotAnswerListener.bind(this);
        ConnectyCube.videochat.onRemoteStreamListener =
            this.onRemoteStreamListener.bind(this);
        ConnectyCube.videochat.onDevicesChangeListener =
            this.onDevicesChangeListener.bind(this);
        ConnectyCube.videochat.onSessionConnectionStateChangedListener =
            this.onSessionConnectionStateChangedListener.bind(this);

        const rejectBtn = document.getElementById("call-modal-reject");
        const freshRejectBtn = rejectBtn.cloneNode(true);
        rejectBtn.replaceWith(freshRejectBtn);
        freshRejectBtn.addEventListener("click", () => this.rejectCall());

        const acceptBtn = document.getElementById("call-modal-accept");
        const freshAcceptBtn = acceptBtn.cloneNode(true);
        acceptBtn.replaceWith(freshAcceptBtn);
        freshAcceptBtn.addEventListener("click", () => this.acceptCall());

        window.onoffline = () => {
            this.isOnline = false;
            console.log("OFFLINE");
        };
        window.ononline = () => {
            console.log("ONLINE");
            if (!this.isOnline) {
                if (this._session && this.needIceRestartForUsersIds.length > 0) {
                    for (let userID of this.needIceRestartForUsersIds) {
                        this.maybeDoIceRestart(this._session, userID);
                    }
                }
            }
            this.isOnline = true;
        };
    };

    $calling = document.getElementById("signal-in");
    $dialing = document.getElementById("signal-out");
    $endCall = document.getElementById("signal-end");

    $modal = document.getElementById("call-modal-incoming");

    $muteUnmuteButton = document.getElementById("videochat-mute-unmute");
    $switchCameraButton = document.getElementById("videochat-switch-camera");
    $switchSharingScreenButton = document.getElementById(
        "videochat-sharing-screen"
    );

    mediaParams = {
        audio: true,
        video: true,
        elementId: "localStream",
        options: {
            muted: true,
            mirror: true,
        },
    };

    sharingScreenMediaParams = {
        audio: true,
        video: {frameRate: {ideal: 10, max: 15}},
        elementId: "localStream",
        options: {
            muted: true,
            mirror: false,
        },
    };

    _session = null;
    videoDevicesIds = [];
    activeVideoDeviceId = null;
    isAudioMuted = false;
    isSharingScreen = false;
    startEventSharingScreen = null;

    defaultSettings = () => {
        if (isMobile) {
            this.$switchSharingScreenButton.disabled = true;
        }
    };

    addStreamElements = (opponents) => {
        const $videochatStreams = document.getElementById("videochat-streams");
        const $videochatStreamsTemplate = document.getElementById(
            "videochat-streams-template"
        );
        const videochatStreamsTemplate = Handlebars.compile(
            $videochatStreamsTemplate.innerHTML
        );

        if (opponents.length === 2) {
            $videochatStreams.classList.value = "grid-2-1";
        } else if (opponents.length === 3) {
            $videochatStreams.classList.value = "grid-2-2";
        }

        document.getElementById("call").classList.add("hidden");
        document.getElementById("videochat").classList.remove("hidden");
        document.getElementById("videochat-streams").classList.remove("hidden");
        $videochatStreams.innerHTML = videochatStreamsTemplate({opponents});
    };

    onCallListener = (session, extension) => {
        if (Number(session.initiatorID) === Number(session.currentUserID)) {
            return false;
        }

        if (this._session) {
            this.rejectCall(session, {busy: true});
            return false;
        }

        this._session = session;
        this.showIncomingCallModal();
    };

    onAcceptCallListener = (session, userId, extension) => {
        if (Number(userId) === Number(session.currentUserID)) {
            if (!this.$modal.classList.contains("hidden")) {
                this._session = null;
                this.hideIncomingCallModal();
                this.showSnackbar("You have accepted the call on other side");
            }

            return false;
        } else {
            this._getUserById(userId, "full_name").then(userName => {
                const infoText = `${userName} has accepted the call`;

                this.showSnackbar(infoText);
                this.$dialing.pause();
            });
        }
    };

    onRejectCallListener = (session, userId, extension = {}) => {
        if (Number(userId) === Number(session.currentUserID)) {
            if (!this.$modal.classList.contains("hidden")) {
                this._session = null;
                this.hideIncomingCallModal();
                this.showSnackbar("You have rejected the call on other side");
            }

            return false;
        } else {
            this._getUserById(userId, "full_name").then(userName => {
                const infoText = extension.busy
                    ? `${userName} is busy`
                    : `${userName} rejected the call request`

                this.stopCall(userId)
                this.showSnackbar(infoText)
            });
        }
    };

    onStopCallListener = (session, userId, extension) => {
        if (!this._session) {
            return false;
        }

        const isStoppedByInitiator = Number(session.initiatorID) === Number(userId);

        this._getUserById(userId, "full_name").then(userName => {
            const infoText = `${userName} has ${
                isStoppedByInitiator ? "stopped" : "left"
            } the call`;
            this.showSnackbar(infoText)

            if (isStoppedByInitiator) {
                if (!this.$modal.classList.contains("hidden")) {
                    this.$modal.classList.add("hidden");
                    this.hideIncomingCallModal();
                }
                this.stopCall();
            } else {
                this.stopCall(userId);
            }
        });
    };

    onUserNotAnswerListener = (session, userId) => {
        if (!this._session) {
            return false;
        }

        this._getUserById(userId, "full_name").then(userName => {
            const infoText = `${userName} did not answer`;

            this.showSnackbar(infoText);
            this.stopCall(userId);
        });
    };

    onRemoteStreamListener = (session, userId, stream) => {
        if (!this._session) {
            return false;
        }

        const remoteStreamSelector = `remoteStream-${userId}`;

        document.getElementById(`videochat-stream-loader-${userId}`).remove();
        this._session.attachMediaStream(remoteStreamSelector, stream);

        this.$muteUnmuteButton.disabled = false;
        this.onDevicesChangeListener();
        this._prepareVideoElement(remoteStreamSelector);
    };

    acceptCall = () => {
        const extension = {};
        const {opponentsIDs, initiatorID, currentUserID, callType} =
            this._session;
        const currentId = Number(currentUserID);
        const opponentsIds = [initiatorID, ...opponentsIDs]
            .map(Number)
            .filter((userId) => currentId !== userId);

        const opponents = [];

        this._getUserById(opponentsIds[0], "full_name").then(userName => {
            opponents.push({"id": opponentsIds[0], "name": userName});
            this.defaultSettings();

            this.addStreamElements(opponents);
            this.hideIncomingCallModal();

            const mediaOptions = {...this.mediaParams};
            if (callType === ConnectyCube.videochat.CallType.AUDIO) {
                delete mediaOptions.video;
            }
            //
            this._session.getUserMedia(mediaOptions).then((stream) => {
                if (
                    !this._session.getDisplayMedia ||
                    callType === ConnectyCube.videochat.CallType.AUDIO
                ) {
                    this.$switchSharingScreenButton.disabled = true;
                }

                this._session.accept(extension);
                this.setActiveDeviceId(stream);
                this._prepareVideoElement("localStream");
            }).catch((error) => {
                console.error("[CallService][acceptCall] getUserMedia error:", error);
                this.showSnackbar(this._mediaErrorMessage(error));
                this.rejectCall(null, {media_error: true});
            });
        });
    };

    rejectCall = (session, extension = {}) => {
        if (session) {
            session.reject(extension);
        } else {
            this._session.reject(extension);
            this._session = null;
            this.hideIncomingCallModal();
        }
    };

    startAudioCall = () => {
        const opponentData = JSON.parse(document.getElementById('call-start-audio').dataset.opponentsParam);
        opponentData.id = parseInt(opponentData.id);
        this.startCall(ConnectyCube.videochat.CallType.AUDIO, opponentData);
    };

    startVideoCall = () => {
        const opponentData = JSON.parse(document.getElementById('call-start-video').dataset.opponentsParam);
        opponentData.id = parseInt(opponentData.id);
        this.startCall(ConnectyCube.videochat.CallType.VIDEO, opponentData);
    };

    startCall = (callType, opponent) => {
        const options = {};

        this.defaultSettings();

        const opponents = [
            opponent
        ];

        const opponentsIds = opponents.map(opponent => opponent.id);

        if (opponents.length > 0) {
            document.getElementById("call").classList.add("hidden");
            document.getElementById("videochat").classList.remove("hidden");
            this._safePlay(this.$dialing);
            this.addStreamElements(opponents);
            this._session = ConnectyCube.videochat.createNewSession(
                opponentsIds,
                callType,
                options
            );

            console.log(
                "startCall",
                {callType},
                ConnectyCube.videochat.CallType.AUDIO
            );

            const mediaOptions = {...this.mediaParams};
            if (callType === ConnectyCube.videochat.CallType.AUDIO) {
                delete mediaOptions.video;
            }
            //
            this._session.getUserMedia(mediaOptions).then((stream) => {
                if (
                    !this._session.getDisplayMedia ||
                    callType === ConnectyCube.videochat.CallType.AUDIO
                ) {
                    this.$switchSharingScreenButton.disabled = true;
                }

                this._session.call({});
                this.setActiveDeviceId(stream);
                this._prepareVideoElement("localStream");
            }).catch((error) => {
                console.error("[CallService][startCall] getUserMedia error:", error);
                this.showSnackbar(this._mediaErrorMessage(error));
                this.stopCall();
            });

            // send push notification when calling

            this._getUserById(this._session.initiatorID, "full_name").then(currentUserName => {
                const params = {
                    message: `Incoming call from ${currentUserName}`,
                    ios_voip: 1,
                    initiatorId: this._session.initiatorID,
                    opponentsIds: opponentsIds.join(","),
                    handle: currentUserName,
                    uuid: this._session.ID,
                    callType:
                        callType === ConnectyCube.videochat.CallType.VIDEO
                            ? "video"
                            : "audio",
                };

                // uncomment if you use Web <-> Flutter
                // const params = {
                //   message: `Incoming call from ${currentUserName}`,
                //   ios_voip: 1,
                //   caller_id: this._session.initiatorID,
                //   call_opponents: opponentsIds.join(","),
                //   caller_name: currentUserName,
                //   session_id: this._session.ID,
                //   call_type: callType,
                //   signal_type: 'startCall'
                // };
                const payload = JSON.stringify(params);
                const pushParameters = {
                    notification_type: "push",
                    user: {ids: opponentsIds},
                    message: ConnectyCube.pushnotifications.base64Encode(payload),
                };

                ConnectyCube.pushnotifications.events
                    .create(pushParameters)
                    .then((result) => {
                        console.log("[sendPushNotification] Ok");
                    })
                    .catch((error) => {
                        console.warn("[sendPushNotification] Error", error);
                    });
            });
        } else {
            this.showSnackbar("Select at less one user to start Videocall");
        }
    };

    stopCall = (userId) => {
        const $callScreen = document.getElementById("call");
        const $videochatScreen = document.getElementById("videochat");
        const $muteButton = document.getElementById("videochat-mute-unmute");
        const $videochatStreams = document.getElementById("videochat-streams");

        if (userId) {
            document.getElementById(`videochat-stream-container-${userId}`).remove();

            const $streamContainers = document.querySelectorAll(
                ".videochat-stream-container"
            );

            if ($streamContainers.length < 2) {
                this.stopCall();
            } else if ($streamContainers.length === 2) {
                $videochatStreams.classList.value = "";
            } else if ($streamContainers.length === 3) {
                $videochatStreams.classList.value = "grid-2-1";
            }
        } else if (this._session) {
            const video = document.getElementById("localStream");
            if (video?.srcObject) {
                for (const track of video.srcObject.getTracks()) {
                    track.stop();
                }
            }

            this._session.stop({});
            ConnectyCube.videochat.clearSession(this._session.ID);
            this.$dialing.pause();
            this.$calling.pause();
            this._safePlay(this.$endCall);
            this.$muteUnmuteButton.disabled = true;
            this.$switchCameraButton.disabled = true;
            this._session = null;
            this.videoDevicesIds = [];
            this.activeVideoDeviceId = null;
            this.isAudioMuted = false;
            $videochatStreams.innerHTML = "";
            $videochatStreams.classList.value = "";
            $callScreen.classList.remove("hidden");
            $videochatScreen.classList.add("hidden");
            $muteButton.classList.remove("muted");

            if (this.isSharingScreen) {
                this.isSharingScreen = false;
                this.updateSharingScreenBtn();
            }

            if (iOS) {
                $videochatScreen.style.background = "#000000";
            }
        }
    };

    onDevicesChangeListener = () => {
        if (iOS) return;

        ConnectyCube.videochat
            .getMediaDevices("videoinput")
            .then((videoDevices) => {
                this.videoDevicesIds = videoDevices?.map(({deviceId}) => deviceId);

                if (
                    this.videoDevicesIds.length < 2 ||
                    this._session.callType === ConnectyCube.videochat.CallType.AUDIO
                ) {
                    this.$switchCameraButton.disabled = true;

                    if (
                        this.activeVideoDeviceId &&
                        this.videoDevicesIds?.[0] !== this.activeVideoDeviceId &&
                        !this.isSharingScreen
                    ) {
                        this.switchCamera();
                    }
                } else {
                    this.$switchCameraButton.disabled = false;
                }
            });
    };

    onSessionConnectionStateChangedListener = (
        session,
        userID,
        connectionState
    ) => {
        console.log(
            "[onSessionConnectionStateChangedListener]",
            userID,
            connectionState
        );

        const {DISCONNECTED, FAILED, CONNECTED, CLOSED} =
            ConnectyCube.videochat.SessionConnectionState;

        if (connectionState === DISCONNECTED || connectionState === FAILED) {
            this.iceRestartTimeout = setTimeout(() => {
                console.log(
                    "Connection not restored within 30 seconds, trying ICE restart.."
                );
                if (this.isOnline) {
                    this.maybeDoIceRestart(session, userID);
                } else {
                    console.log("Skip ICE restart, no Internet connection ");
                    this.needIceRestartForUsersIds.push(userID);
                }
            }, 30000);
        } else if (connectionState === CONNECTED) {
            clearTimeout(this.iceRestartTimeout);
            this.iceRestartTimeout = null;

            this.needIceRestartForUsersIds = [];
        } else if (connectionState === CLOSED) {
            this.needIceRestartForUsersIds = [];
        }
    };

    async maybeDoIceRestart(session, userID) {
        console.log("[maybeDoIceRestart] Chat PING");
        //
        try {
            await ConnectyCube.chat.pingWithTimeout();

            console.log("[maybeDoIceRestart] Chat PONG");

            console.log(
                "[maybeDoIceRestart] canInitiateIceRestart: ",
                session.canInitiateIceRestart(userID)
            );

            if (session.canInitiateIceRestart(userID)) {
                console.log("[maybeDoIceRestart] do ICE restart");
                session.iceRestart(userID);
            }
        } catch (error) {
            console.error(error.message);

            console.log("[maybeDoIceRestart] do Chat restart");

            await ConnectyCube.chat.disconnect();

            // Reconnect using stored credentials
            if (this.currentUser) {
                await ConnectyCube.chat.connect({
                    userId: this.currentUser.id,
                    password: this.currentUser.password,
                });
            }

            console.log("[maybeDoIceRestart] Chat restarted");

            console.log(
                "[maybeDoIceRestart] canInitiateIceRestart: ",
                session.canInitiateIceRestart(userID)
            );

            if (session.canInitiateIceRestart(userID)) {
                console.log("[maybeDoIceRestart] do ICE restart");
                session.iceRestart(userID);
            }
        }
    }

    setActiveDeviceId = (stream) => {
        if (stream && !iOS) {
            const videoTracks = stream.getVideoTracks();
            const videoTrackSettings = videoTracks[0]?.getSettings();

            this.activeVideoDeviceId = videoTrackSettings?.deviceId;
        }
    };

    setAudioMute = () => {
        const $muteButton = document.getElementById("videochat-mute-unmute");

        if (this.isAudioMuted) {
            this._session.unmute("audio");
            this.isAudioMuted = false;
            $muteButton.classList.remove("muted");
        } else {
            this._session.mute("audio");
            this.isAudioMuted = true;
            $muteButton.classList.add("muted");
        }
    };

    switchCamera = () => {
        const videoDevicesId = this.videoDevicesIds.find(
            (deviceId) => deviceId !== this.activeVideoDeviceId
        );

        this._session.switchMediaTracks({video: videoDevicesId}).then(() => {
            this.activeVideoDeviceId = videoDevicesId;

            if (this.isAudioMuted) {
                this._session.mute("audio");
            }
        });
    };

    sharingScreen = () => {
        if (!this.isSharingScreen) {
            return this._session
                .getDisplayMedia(this.sharingScreenMediaParams, true)
                .then(
                    (stream) => {
                        this.updateStream(stream);
                        this.isSharingScreen = true;
                        this.updateSharingScreenBtn();
                        this.startEventSharingScreen = stream
                            .getVideoTracks()[0]
                            .addEventListener("ended", () => this.stopSharingScreen());
                    },
                    (error) => {
                        console.warn("[Get display media error]", error, this.mediaParam);
                        this.stopSharingScreen();
                    }
                );
        } else {
            this.stopSharingScreen();
        }
    };

    updateSharingScreenBtn = () => {
        const $videochatSharingScreen = document.getElementById(
            "videochat-sharing-screen"
        );
        const $videochatSharingScreenIcon = document.getElementById(
            "videochat-sharing-screen-icon"
        );

        if (this.isSharingScreen) {
            $videochatSharingScreen.classList.add("videochat-sharing-screen-active");
            $videochatSharingScreenIcon.classList.add(
                "videochat-sharing-screen-icon-active"
            );
        } else {
            $videochatSharingScreen.classList.remove(
                "videochat-sharing-screen-active"
            );
            $videochatSharingScreenIcon.classList.remove(
                "videochat-sharing-screen-icon-active"
            );
        }
    };

    stopSharingScreen = () => {
        return this._session.getUserMedia(this.mediaParams, true).then((stream) => {
            this.updateStream(stream);
            this.isSharingScreen = false;
            this.updateSharingScreenBtn();
            this.startEventSharingScreen = null;
        });
    };

    updateStream = (stream) => {
        this.setActiveDeviceId(stream);
        this._prepareVideoElement("localStream");
    };

    /* SNACKBAR */

    showSnackbar = (infoText) => {
        const $snackbar = document.getElementById("snackbar");

        $snackbar.innerHTML = infoText;
        $snackbar.classList.remove("hidden");

        setTimeout(function () {
            $snackbar.innerHTML = "";
            $snackbar.classList.add("hidden");
        }, 3000);
    };

    /*INCOMING CALL MODAL */

    showIncomingCallModal = () => {
        console.log("Incoming call");
        const $initiator = document.getElementById("call-modal-initiator");
        this._getUserById(this._session.initiatorID, "full_name").then(userName => {
            $initiator.innerHTML = userName;
        });

        this.$modal.classList.remove("hidden");
        this._safePlay(this.$calling);
    };

    hideIncomingCallModal = () => {
        const $initiator = document.getElementById("call-modal-initiator");

        $initiator.innerHTML = "";
        this.$modal.classList.add("hidden");
        this.$calling.pause();
    };


    async _getUserById(userId, key) {
        try {
            const params = {
                filter: {
                    field: 'id',
                    param: 'in',
                    value: [userId] // Pass ID here as array
                },
                sort: {
                    field: 'id',
                    order: 'desc'
                },
                per_page: 1
            };

            const result = await ConnectyCube.users.get(params);

            return typeof key === "string" ? (result.items[0]["user"].full_name) : (result.items[0]["user"]);
        } catch (error) {
            console.error("Error fetching user:", error);
            throw error;
        }
    }

    _prepareVideoElement = (videoElement) => {
        const $video = document.getElementById(videoElement);

        $video.style.visibility = "visible";

        if (iOS) {
            document.getElementById("videochat").style.background = "transparent";
            $video.style.backgroundColor = "";
            $video.style.zIndex = -1;
        }
    };

    _safePlay = (element) => {
        if (!element) return;
        const promise = element.play();
        if (promise !== undefined) {
            promise.catch(() => {
            });
        }
    };

    _mediaErrorMessage = (error) => {
        switch (error.name) {
            case "NotReadableError":
                return "Microphone or camera is busy. Please close other apps using it.";
            case "NotAllowedError":
                return "Please allow microphone and camera access to make calls.";
            case "NotFoundError":
                return "No microphone or camera found on this device.";
            default:
                return "Could not access microphone or camera. Please try again.";
        }
    };
}

export default new CallService();
